// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3z2CH","head":"ProcedureTableInfo_head__zrZUL"};